"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var product_document_templates_html_1 = __importDefault(require("./product-document-templates.html"));
var product_document_templates_controller_1 = __importDefault(require("./product-document-templates.controller"));
function dsProductDocumentTemplates() {
    return {
        restrict: "E",
        scope: {
            product: "=",
        },
        template: product_document_templates_html_1.default,
        link: function (scope, element, attrs) { },
        controller: product_document_templates_controller_1.default,
        controllerAs: "vm",
        bindToController: true,
    };
}
exports.default = angular_1.default
    .module("admin.directives.productdocumenttemplates", [])
    .controller("dsProductDocumentTemplatesController", product_document_templates_controller_1.default)
    .directive("dsProductDocumentTemplates", dsProductDocumentTemplates);
